import { useDispatch, useSelector } from "react-redux";
import { uiActions } from "../../../store/reducers/ui";

import { Dialog, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";

import ReactGA from "react-ga4";

import constants, { GA_STEP } from "../../../utils/constants";
import PreQualify from "./PreQualify";
import NotQualified from "./NotQualified";
import Stepper from "./Stepper";
import Confirmation from "./Confirmation";
import OtherOccupants from "./OtherOccupants";
import { useEffect } from "react";

if (process.env.REACT_APP_GA_ID) {
  console.log("Setting up GA");

  ReactGA.initialize([
    {
      trackingId: process.env.REACT_APP_GA_ID,
    },
  ]);
}

const sendToAnalytics = (stepId, title) => {
  if (process.env.REACT_APP_GA_ID) {
    const params = window.location.search;

    ReactGA.send({
      hitType: "pageview",
      page: `${window.location.pathname}${params}#stage${stepId}`,
      title: `Booking App: ${title}`,
    });
  }
};

export default function WidgetDialog(props) {
  const { branchInfoLoading, requestType } = props;

  const dispatch = useDispatch();

  const widgetOpen = useSelector((state) => state.ui.widgetOpen);
  const bookingStatus = useSelector((state) => state.booking.bookingStatus);

  const isMobile = useMediaQuery(useTheme().breakpoints.down("sm"));
  const qualified =
    bookingStatus === constants.BOOKING_STATUS.QUALIFIED || bookingStatus === constants.BOOKING_STATUS.PRE_QUALIFIED;
  const extraOccupantsStatus =
    bookingStatus === constants.BOOKING_STATUS.EXTRA_OCCUPANTS ||
    bookingStatus === constants.BOOKING_STATUS.EXTRA_OCCUPANTS_QUALIFIED;

  const handleDialoglose = (event, reason) => {
    dispatch(uiActions.closeWidget({ reason, requestType }));
  };

  useEffect(() => {
    if (
      bookingStatus &&
      (!qualified || extraOccupantsStatus || bookingStatus === constants.BOOKING_STATUS.NOT_QUALIFIED)
    ) {
      const stepDescription =
        bookingStatus === constants.BOOKING_STATUS.QUALIFYING
          ? "Qualifying"
          : extraOccupantsStatus
          ? "Extra Occupants"
          : bookingStatus === constants.BOOKING_STATUS.COMPLETE
          ? "Complete"
          : "Not Qualified";

      sendToAnalytics(GA_STEP[stepDescription], stepDescription);
    }
  }, [bookingStatus, extraOccupantsStatus, qualified]);

  return bookingStatus !== constants.BOOKING_STATUS.NOT_QUALIFIED ? (
    <Dialog
      id="widgetDialog"
      open={widgetOpen}
      fullScreen={qualified || (extraOccupantsStatus && isMobile)}
      maxWidth={
        extraOccupantsStatus && !isMobile
          ? "md"
          : bookingStatus === constants.BOOKING_STATUS.COMPLETE ||
            bookingStatus === constants.BOOKING_STATUS.COMPLETE_EXTRA_OCCUPANTS
          ? "sm"
          : undefined
      }
    >
      <div id="widgetTop"></div>

      {bookingStatus === constants.BOOKING_STATUS.QUALIFYING && <PreQualify onClose={handleDialoglose} />}
      {qualified && <Stepper loading={branchInfoLoading} onSendToGA={sendToAnalytics} />}
      {(bookingStatus === constants.BOOKING_STATUS.COMPLETE ||
        bookingStatus === constants.BOOKING_STATUS.COMPLETE_EXTRA_OCCUPANTS) && (
        <Confirmation onClose={handleDialoglose} />
      )}
      {extraOccupantsStatus && <OtherOccupants />}
    </Dialog>
  ) : (
    <NotQualified open={widgetOpen} onClose={handleDialoglose} />
  );
}
